import React from "react";
import css from './toggle_switch.module.scss';
import classNames from 'classnames';

type Props = {
	id: string,
	checked: boolean,
	onChange: (val: boolean) => void,
	name?: string,
	optionLabels?: string[],
	small?: boolean,
	disabled?: boolean,
	label?: string,
	labelPosition?: 'left' | 'right',
	className?: string
}

export const ToggleSwitch = (props: Props) => {
	function handleKeyPress(e) {
		if (e.keyCode !== 32) return;
		
		e.preventDefault();
		props.onChange(!props.checked)
	}
	
	return (
		<div className={
			classNames(
				css.root,
				props.className,
				{[css.root_left]: props.labelPosition === "left"},
				{[css.root_right]: props.labelPosition === "right"}
			)
		}>
			{props.label &&<span className={css.toggle_switch_title}>{props.label}</span>}
		
			<div className={classNames(css.toggle_switch, {[css.small_switch]: props.small})}>
				<input
					type="checkbox"
					name={props.name}
					className={css.toggle_switch_checkbox}
					id={props.id}
					checked={props.checked}
					onChange={e => props.onChange(e.target.checked)}
					disabled={props.disabled}
				/>
				{props.id ? (
					<label className={css.toggle_switch_label}
		       htmlFor={props.id}
		       tabIndex={props.disabled ? -1 : 1}
		       onKeyDown={(e) => {
			       handleKeyPress(e)
		       }}>
	            <span
		            className={
			            props.disabled
				            ? classNames(css.toggle_switch_inner, css.toggle_switch_disabled)
				            : classNames(css.toggle_switch_inner)
		            }
		            data-yes={props.optionLabels[0]}
		            data-no={props.optionLabels[1]}
		            tabIndex={-1}
	            />
							<span
								className={
									props.disabled
										? classNames(css.toggle_switch_switch, css.toggle_switch_disabled)
										: classNames(css.toggle_switch_switch)
								}
								tabIndex={-1}
							/>
					</label>
				) : null}
			</div>
		</div>
	);
}

ToggleSwitch.defaultProps = {
	optionLabels: ["Yes", "No"],
	disabled: false,
	small: false,
	labelPosition: 'left'
};
